import React from "react";

import { GetStaticProps } from "next";
import {
  ATypeBeneficiaryHead,
  ATypeCardView,
  BTypeBreadCrumb,
  GOI_WEB_URL,
} from "goi_common";
import crematorium from "goi_common/src/constants/hwajang_detail.json";
import facilities from "goi_common/src/constants/facilities_detail.json";
import { parlorRegion } from "@/constants/parlorRegion";
import { Box, Stack } from "@mui/material";
import Head from "next/head";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticProps: GetStaticProps = async () => {
  const regionCrematoriums = crematorium.filter((p) =>
    targetSidos.includes(String(p.sido))
  );
  const regionPublicFacilities = facilities.filter(
    (f) => targetSidos.includes(f.sido) && f.is_public
  );
  const description = "충청 대전 세종 기초생활수급자 장례 혜택 4가지 안내";

  return {
    props: {
      regionCrematoriums,
      regionPublicFacilities,
      pageDescription: description,
      pageKeywords: `기초생활수급자 장례, 기초생활수급자 장례, 장제비, 장제급여, 기초생활수급자 장례 얼마`,
      pageOgTitle: `기초생활수급자 장례 시 114, 요약 (대전충청세종) ::  충청대전세종장례소개포털`,
      pageOgDescription: description,
      pageOgImage: "",
    },
  };
};

export default function index({
  regionCrematoriums,
  regionPublicFacilities,
  pageOgTitle,
}: {
  regionCrematoriums: Array<any>;
  regionPublicFacilities: Array<any>;
  pageOgTitle: string;
}) {
  const carouselItems = regionCrematoriums.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://www.ch-funeralportal.co.kr/benefit-support/free-crema/${res.companyname} 기초생활수급자 안내`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionCrematoriums.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};
  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>
        {regionCrematoriums.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>
      <BTypeBreadCrumb
        firstItem={{
          text: `기초수급자장례 추천`,
          href: `${GOI_WEB_URL}?utm_source=dogsound` + "/match/request/?utm_source=dogsound",
          event: {
            domain: "ch",
            path: "benef_sup",
            trigger_and_target: "br_crumb_mth_req",
          },
        }}
        secondItem={{
          text: `기초생활수급자 장례114`,
          href: `/benefit-support/`,
          event: {
            domain: "ch",
            path: "benef_sup",
            trigger_and_target: "br_crumb_benef_sup",
          },
        }}
        goiHomeEvent={{
          domain: "ch",
          path: "benef_sup",
          trigger_and_target: "br_crumb_goi_home",
        }}
      />

      <ATypeBeneficiaryHead
        titleSido="충청 · 대전 · 세종"
        mainColor={regionColor}
        event={{
          domain: "ch",
          path: "benef_sup",
          trigger_and_target: "goi_call",
        }}
      />

      <Stack
        padding="24px 16px 10px"
        gap="12px"
        style={{ background: regionColor.c100 }}
      >
        <h3 className="subtitle_18_b">
          충청 대전 세종 기초생활수급자 무료 화장장
        </h3>
        {regionCrematoriums.map((res) => (
          <ATypeCardView
            key={res.companyname}
            name={res.companyname}
            href={`/benefit-support/free-crema/${res.companyname} 기초생활수급자 안내/`}
            descriptions={["기초생활수급자 무료"]}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            event={{
              domain: "ch",
              path: "benef_sup",
              trigger_and_target: "benef_fr_crema-uv_crema",
            }}
          />
        ))}
      </Stack>

      <Stack padding="24px 16px 10px" gap="12px">
        <h3 className="subtitle_18_b">
          충청 대전 세종 기초생활수급자 무료 장지 (공설)
        </h3>
        {regionPublicFacilities.map((res) => (
          <ATypeCardView
            key={res.companyname}
            name={res.companyname}
            href={`/benefit-support/free-facility/${res.companyname} 기초생활수급자 안내/`}
            // descriptions={["기초생활수급자 무료"]}
            descriptions={[""]}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            event={{
              domain: "ch",
              path: "benef_sup",
              trigger_and_target: "benef_fr_fac-uv_fac",
            }}
          />
        ))}
      </Stack>
    </>
  );
}
